import { putMethodWithToken } from 'services/apiServices';
import url from 'services/urls.json';
import { ClearTokenRedirectLogin } from 'utils/general';

// Action Types
export const UPDATE_COMPANY_BRANCH_PROVIDER = 'UPDATE_COMPANY_BRANCH_PROVIDER';
export const UPDATE_COMPANY_BRANCH_PROVIDER_SUCCESS =
  'UPDATE_COMPANY_BRANCH_PROVIDER_SUCCESS';
export const UPDATE_COMPANY_BRANCH_PROVIDER_FAILURE =
  'UPDATE_COMPANY_BRANCH_PROVIDER_FAILURE';

// Action Creators
export const fetchUpdateCompanyBranchProvider = () => ({
  type: UPDATE_COMPANY_BRANCH_PROVIDER,
});

export const fetchUpdateCompanyBranchProviderSuccess = (data) => ({
  type: UPDATE_COMPANY_BRANCH_PROVIDER_SUCCESS,
  payload: data,
});

export const fetchUpdateCompanyBranchProviderFailure = (error) => ({
  type: UPDATE_COMPANY_BRANCH_PROVIDER_FAILURE,
  payload: error,
});

// Thunk Function
export const updateCompanyBranchProviderCallAPI = (data, external = {}) => {
  return async (dispatch) => {
    dispatch(fetchUpdateCompanyBranchProvider(data, external));
    try {
      const response = await putMethodWithToken(
        url.updateCompanyBranchProvider + external?.id + '/update/',
        data
      );
      if (response.status === 200 || response.status === 201) {
        dispatch(fetchUpdateCompanyBranchProviderSuccess(response.data));

        if (external && external.redirect === true) {
          external.redirectNavigate(external.path);
        } else if (external && external.run === true) {
          external.handleFunction(response);
        } else if (external && external.step) {
          external.handleStep(external.step);
        }
      } else if (response.status === 401) {
        ClearTokenRedirectLogin(external?.navigate);
      } else {
        dispatch(fetchUpdateCompanyBranchProviderFailure('Error'));
        if (external && external.toast) {
          external.handleToastError(response);
        }
      }
    } catch (error) {
      dispatch(fetchUpdateCompanyBranchProviderFailure(error.message));
    }
  };
};
